<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <contributions-form>
        </contributions-form>
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import contributionsForm from './todo-contributions-form'
export default {
    components: {
        contributionsForm
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-contributions/base-contributions-form.vue